import { action, computed, observable } from 'mobx';
import { setter } from 'mobx-decorators';
import uniqueId from 'lodash/uniqueId';
import * as constants from 'Constants';
import { deserializeWithMappers, setFieldValues } from 'stores/Utils';


class MediaStore {

  @setter @observable id;
  @setter @observable uploadId;
  @setter @observable reactId;
  @setter @observable src;

  static create(data={}) {
    const instance = new MediaStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "id": null,
      "uploadId": null,
      "reactId": uniqueId(),
      "src": "",
    };
  }

  constructor(defaults=MediaStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=MediaStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "id"},
      {"field": "src", "accessor": "file_url"},
    ];
  }

  @action deserialize(data) {
   deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }

  serialize() {
    return {
      'id': this.id,
      'file_url': this.src,
    }
  }

  get fileName() {
    if (!this.src) return '';
    return this.src.substring(this.src.lastIndexOf('/')+1);
  }
}


export default MediaStore;
